export default __webpack_public_path__ + "static/NeoSansPro-Medium-eb072a88edbf02afd9f91ea2072a7c29.woff";